/**
 * Normalize legacy Clearbit logo URLs to Google favicon service.
 */
export function normalizeStoreLogoUrl(url) {
  if (!url || typeof url !== "string") return url;

  const clearbitMatch = url.match(/logo\.clearbit\.com\/([^/?#]+)/i);
  if (clearbitMatch) {
    return `https://www.google.com/s2/favicons?domain=${clearbitMatch[1]}&sz=128`;
  }

  return url;
}
